export const getTruncatedTouchpointsName = (touchpointName: string) => {
  return touchpointName.length > 52 ? touchpointName.slice(0, 52) + "..." : touchpointName;
};
